import { Loader2 } from 'lucide-react';
import { EmptyState, Spinner } from '@/components/ui/EmptyState';
import type { TransferTarget } from '@/lib/sipApi';

// Shared "pick a staff member's extension" list — used by both the Phone
// page's own Transfer modal and AppShell's global floating call widget
// (Transfer + Add to Conference), so the two don't drift out of sync.
export function CallTargetPicker({
  targets,
  loading,
  busyId,
  onPick,
}: {
  targets: TransferTarget[];
  loading: boolean;
  busyId?: string | null;
  onPick: (t: TransferTarget) => void;
}) {
  if (loading) return <Spinner />;
  if (targets.length === 0) {
    return (
      <EmptyState
        title="No other staff have an active extension"
        hint="Ask an admin to set one up from ERP: Settings > SIP Accounts."
      />
    );
  }
  return (
    <div className="space-y-1.5">
      {targets.map((t) => (
        <button
          key={t.user_id}
          type="button"
          onClick={() => onPick(t)}
          disabled={!!busyId}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl border border-border-subtle hover:bg-surface-muted hover:border-primary-200 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed text-left"
        >
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary-700 to-primary-900 text-white flex items-center justify-center text-[11px] font-bold flex-shrink-0">
            {t.display_name.slice(0, 1).toUpperCase()}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[13px] font-semibold text-ink truncate">{t.display_name}</p>
            <p className="text-[11px] text-ink-faint">Ext. {t.extension}</p>
          </div>
          {busyId === t.user_id && <Loader2 className="w-4 h-4 animate-spin text-primary-700 flex-shrink-0" />}
        </button>
      ))}
    </div>
  );
}
